import { Container, Box, FormControl, Link, Input, Button } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import RouteName from 'config/routes';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useLazyGetCompanyUserQuery, useOAuthMutation } from 'services/authCompany';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb } from 'apps/company/components';
import yup from 'shared/yubGlobal';
import Loading from 'apps/company/utils/loading';
import useTitle from 'hooks/useTitle';

function Login(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useTitle(t('common:pageTitle:login'));
  const schema = yup.object().shape({
    email: yup
      .string()
      .required(t('validate:requiredEmail'))
      .max(255, t('validate:oversizedEmail'))
      .email(t('validate:invalidEmail')),
    password: yup
      .string()
      .required(t('validate:requiredPassword'))
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const [oAuth, { isLoading }] = useOAuthMutation();
  const [getCompanyUser] = useLazyGetCompanyUserQuery();
  const watchEmail = watch('email', '');
  const watchPassword = watch('password', '');

  React.useEffect(() => {
    isLoading ? Loading.openLoading() : Loading.closeLoading()
  }, [isLoading])

  function handleLogin(data) {
    Loading.openLoading()
    const params = {
      ...data,
      grant_type: 'password',
      account_type: 'CompanyUser'
    };
    oAuth(params)
      .unwrap()
      .then(async (payload) => {
        localStorage.setItem('adminToken', payload.access_token);
        const res = await getCompanyUser().unwrap()
        if (res?.company_user) {
          navigate(RouteName.systemNotification)
        }
      })
      .catch(() => {})
      .finally(() => {
        Loading.closeLoading()
      });
  }

  return (
    <div>
      <Container>
        <Breadcrumb content={t('login:title')}></Breadcrumb>
        <form>
          <FormControl error={errors.email}>
            <Input
              type="email"
              placeholder={t('login:inputEmail')}
              {...register('email')}
            ></Input>
          </FormControl>
          <FormControl error={errors.password}>
            <Input
              type="password"
              placeholder={t('login:inputPassword')}
              {...register('password')}
            ></Input>
          </FormControl>
          <Box pt={24}>
            <Button
              variant="outlined"
              disabled={(!watchEmail || !watchPassword) || isLoading}
              onClick={handleSubmit(handleLogin)}
            >
              {t('login:txtBtnLogin')}
            </Button>
          </Box>
        </form>
        <Box pt={24} textAlign="center">
          <Link to={RouteName.forgotPassword} underline="always">
            {t('login:forgotPassword')}
          </Link>
        </Box>
      </Container>
    </div>
  );
}

export default Login;
